import React, { useState, useEffect } from 'react';
import './razorpay.scss';
import logo from './oc-logo.png';
import { paymentStatusService } from './apis';
import PaymentModal from '../PaymentModal';
import { dateString, reloadPage } from '../../sagas/utilities';

function Razorpay({ amount = '', orderId = '', currency = 'INR', description = 'Fellowship', orderDetails, usersInfo, openRazorpay, launchTime, isLive, setOpenRazorpay, onPaymentSuccess }) {
  const [visiblePaymentSucceedModal, setVisiblePaymentSucceedModal] = useState(false);
  const [visiblePaymentFailedModal, setVisiblePaymentFailedModal] = useState(false);

  useEffect(() => {
    if (openRazorpay) {
      setVisiblePaymentSucceedModal(false);
      setVisiblePaymentFailedModal(false);
      displayRazorpay();
    }
  }, [openRazorpay]);

  const displayRazorpay = async () => {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');
    if (!res) {
      alert('Your are offline... failed to load Razorpay SDK');
      return;
    }

    const options = {
      key: 'rzp_live_4VdRBRk11cFFcY', // live: rzp_live_4VdRBRk11cFFcY  // test: rzp_test_52I2S1FJEaOnJI (dev's personal)
      amount: amount.toString(),
      currency: currency,
      order_id: orderId,
      name: 'Omnicuris Healthcare Pvt Ltd.',
      description: description + ' Charges',
      timeout: 600,
      image: logo,
      handler: function (response) {
        const payload = {
          ...orderDetails,
          status: response.razorpay_payment_id ? 'SUCCESS' : '',
          orderId: response.razorpay_order_id,
          paymentId: response.razorpay_payment_id,
          signature: response.razorpay_signature ? response.razorpay_signature : '',
        };
        paymentUpdate(payload);
        if (response.razorpay_payment_id) {
          setVisiblePaymentSucceedModal(true);
        }
        if (onPaymentSuccess) {
          onPaymentSuccess();
        }
      },
      modal: {
        ondismiss: function () {
          const payload = { ...orderDetails, status: 'CANCEL', orderId: orderId };
          paymentUpdate(payload);
          setOpenRazorpay(false);
        },
      },
      prefill: {
        name: usersInfo.name,
        email: usersInfo.email,
        contact: usersInfo.contact,
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.on('payment.failed', function (response) {
      const payload = { ...orderDetails, status: response.error.metadata.payment_id ? 'FAIL' : '', orderId: response.error.metadata.order_id, paymentId: response.error.metadata.payment_id };
      paymentUpdate(payload);
      // setVisiblePaymentFailedModal(true);
      setOpenRazorpay(false);
    });
    paymentObject.open();
  };

  const loadScript = (src) => {
    return new Promise((resolved) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        resolved(true);
      };
      script.onerror = () => {
        resolved(false);
      };
      document.body.appendChild(script);
    });
  };

  const paymentUpdate = (payload) => {
    paymentStatusService(payload)
      .then((response) => console.log(''))
      .catch((error) => console.log(error));
  };

  const handlePaymentModal = () => {
    setVisiblePaymentSucceedModal(false);
    setVisiblePaymentFailedModal(false);
    setOpenRazorpay(false);
    reloadPage();
  };

  return (
    <div>
      <PaymentModal
        modalTitle='Payment Successful'
        visible={visiblePaymentSucceedModal}
        setVisible={setVisiblePaymentSucceedModal}
        status='success'
        buttonTitle='Done'
        buttonAction={handlePaymentModal}
      >
        <p>Congratulations! Your payment is successful. {launchTime && (isLive ? 'You can join now.' : `The webinar starts on ${dateString(launchTime)} and you can join 10 minutes before.`)}</p>
      </PaymentModal>
      <PaymentModal
        modalTitle='Payment Failed'
        visible={visiblePaymentFailedModal}
        setVisible={setVisiblePaymentFailedModal}
        status='failed'
        buttonTitle='Try Again'
        buttonAction={() => setOpenRazorpay(true)}
      >
        <p>
          Transaction could not be completed. Please try again to access the contents of the {description}
          {isLive ? '' : `on ${dateString(launchTime)}`}.
        </p>
      </PaymentModal>
    </div>
  );
}

export default Razorpay;
